export const G4S_FEEDBACK_REASONS_THUMBS_UP = [
    "Explore with AI suggested content was relevant to my prompt.",
    "'Why did we suggest this?' explaination was accurate.",
];

export const G4S_FEEDBACK_REASONS_THUMBS_DOWN = [
    "Explore with AI suggested content was not relevant to my prompt.",
    "'Why did we suggest this?' explaination was not accurate.",
    "Experienced an error.",
    "Other.",
];

export const G4S_EMAIL_FEEDBACK_REASONS_THUMBS_UP = [
    "Explore with AI generated email was relevant to my prompt.",
    "Explore with AI generated email cited the added insights accurately.",
];

export const G4S_EMAIL_FEEDBACK_REASONS_THUMBS_DOWN = [
    "Explore with AI generated email was not relevant to my prompt.",
    "Explore with AI generated email cited the added insights inaccurately.",
    "Experienced an error.",
    "Other.",
];

export const G4S_DECORATION_FEEDBACK_REASONS_THUMBS_UP = [
    "AI generated summary was relevant to my prompt.",
    "AI generated summary cited the added insights accurately.",
    "AI generated email was relevant to my prompt.",
    "AI generated email cited the added insights accurately.",
];

export const G4S_DECORATION_FEEDBACK_REASONS_THUMBS_DOWN = [
    "AI generated summary was not relevant to my prompt.",
    "AI generated summary cited the added insights inaccurately.",
    "AI generated email was not relevant to my prompt.",
    "AI generated email cited the added insights inaccurately.",
    "Experienced an error.",
    "Other.",
];
